import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b666daa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "table-container" }
const _hoisted_6 = { class: "modern-table" }
const _hoisted_7 = { style: {"width":"60px","height":"60px"} }
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ChannelService from '@/services/ChannelService'
import { onMounted, ref } from 'vue';
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import router from '@/router';
import FollowChannelButton from '@/components/widgets/FollowChannelButton.vue';
import SocialProfileImage from '@/components/widgets/SocialProfileImage.vue';
import main from '@/data/main.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'HallOfFame',
  setup(__props) {

const service = new ChannelService()
const filtered = ref([])
const loading = ref(true)
const search = ref('')
const toast = useToast()
const mostReputated = ref()


onMounted(async () => {
    loading.value = true
    mostReputated.value = await service.GetMostReputatedChannels()
    loading.value = false
})

const readMore = (id: number) => {
    router.push({ name: 'social-profile', params: { id: id } })
}



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_unref(main).TITLE_HALL_OF_FAME), 1),
            _hoisted_3,
            _createElementVNode("h3", null, _toDisplayString(_unref(main).SUBTITLE_HALL_OF_FAME), 1),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("table", _hoisted_6, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_1_HALL_OF_FAME), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_2_HALL_OF_FAME), 1),
                    _createElementVNode("th", null, _toDisplayString(_unref(main).TH_3_HALL_OF_FAME), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mostReputated.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(SocialProfileImage, { user: item }, null, 8, ["user"])
                        ])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(index + 1) + ". " + _toDisplayString(item.name) + " (" + _toDisplayString(item.reputation.toLocaleString()) + ")", 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_v_icon, {
                            name: "md-fileopen-round",
                            class: "ver",
                            fill: _unref(main).SECONDARY_COLOR,
                            scale: "2",
                            onClick: ($event: any) => (readMore(item.id))
                          }, null, 8, ["fill", "onClick"]),
                          _createVNode(FollowChannelButton, {
                            user_id: item.id
                          }, null, 8, ["user_id"])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})